import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Meta = (props) => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charset='utf-8' />
                     {/* SEO 태그 */}
                    <title>{props.title}</title>
                    <meta name='description' content={props.descriptopn} />
                    <meta name='keywords' content={props.keywords} />
                    <meta name='author' content={props.author} />
                    <meta name='og:type' content={'website'} />
                    <meta name='og:title' content={props.title} />
                    <meta name='og:description' content={props.descriptopn} />
                    <meta name='og:url' content={props.url} />
                    {/* <meta name='og:image' content={props.image} /> */}


                    
                    {/* Helmet 안에서 CSS 적용하기 */}
                    <style type="text/css">{`
                    @font-face {
                        font-family: 'AppleSDGothicNeoB';
                        src: url('/assets/fonts/AppleSDGothicNeoB.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoEB';
                        src: url('/assets/fonts/AppleSDGothicNeoEB.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoH';
                        src: url('/assets/fonts/AppleSDGothicNeoH.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoL';
                        src: url('/assets/fonts/AppleSDGothicNeoL.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoM';
                        src: url('/assets/fonts/AppleSDGothicNeoM.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoR';
                        src: url('/assets/fonts/AppleSDGothicNeoR.ttf') format('truetype');
                    }


                    @font-face {
                        font-family: 'AppleSDGothicNeoSB';
                        src: url('/assets/fonts/AppleSDGothicNeoSB.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoT';
                        src: url('/assets/fonts/AppleSDGothicNeoT.ttf') format('truetype');
                    }

                    @font-face {
                        font-family: 'AppleSDGothicNeoUL';
                        src: url('/assets/fonts/AppleSDGothicNeoUL.ttf') format('truetype');
                    }

                    * {
                        text-decoration: none;
                        color: black;
                        list-style: none;
                        font-family: 'AppleSDGothicNeoR', sans-serif;
                    }

                    h1 {
                        margin: 0;
                    }

                    body {
                        margin: 0;
                        padding: 0;
                    }

                    `}</style>
            </Helmet>
        </HelmetProvider>
    );
};

Meta.defaultProps = {
    title: 'Junbeom Woo',
    description : 'About Me',
    keywords: 'Junbeom',
    author: 'Junbeom',
    // image: '기본이미지변수적용'
    url: window.location.href,
};

export default Meta;